import { z } from "zod";

export const DepositTokenTypeEnum = {
  PAXG: "PAXG",
  TetherERC20: "TetherERC20",
  TetherBEP20: "TetherBEP20",
  BNB: "BNB",
  ETH: "ETH",
  Profit: "PROFIT",
  GGOLD: "GGOLD",
} as const;

export const depositTokenTypeSchema = z.enum([
  DepositTokenTypeEnum.PAXG,
  DepositTokenTypeEnum.TetherERC20,
  DepositTokenTypeEnum.TetherBEP20,
  DepositTokenTypeEnum.BNB,
  DepositTokenTypeEnum.ETH,
  DepositTokenTypeEnum.Profit,
  DepositTokenTypeEnum.GGOLD,
]);

export type DepositTokenType = z.infer<
  typeof depositTokenTypeSchema
>;